module.exports = __webpack_public_path__ + "static/img/101-award.5540759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/101-award.png
// module id = omh/
// module chunks = 1